var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0,
};

site.device = {
	// Check if device is a touch device
	isTouch: function () {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	},
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.frontpage = {
	init: function() {

	}
};

site.popUp = {
	init: function() {
		var popUp = document.getElementById("languagePopUp");
		var btn = document.getElementsByClassName("qn_language")[0];
		var close = document.getElementById("closePopUp");

		if(btn) {
			btn.onclick = function() {
				popUp.style.display = "block";
			};
		}
		close.onclick = function() {
			popUp.style.display = "none";
		};
		window.onclick = function(event) {
			if (event.target == popUp) {
				popUp.style.display = "none";
			}
		};

		if(!sessionStorage.getItem("hasSeenPopUp") && !$('body').is('.admin') && !$('body').is('.auth')) {
			window.onload = (event) => {
				popUp.style.display = "block";
				sessionStorage.setItem("hasSeenPopUp", "seen");
			};
		}
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.popUp.init();
	//site.svg.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.formbuilder')) {
		site.fileupload.init('#file');
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

MoyaAutocomplete.prototype.createResultItemLabel = function(data, linkElement) {
	const wrap = document.createElement('div');
	wrap.classList.add('result__wrap');

	const content = document.createElement('div');
	content.classList.add('result__content');
	content.textContent = data.content;

	const label = document.createElement('span');
	label.classList.add('result__label');

	const title = document.createElement('span');
	title.classList.add('result__title');
	title.textContent = data.label;

	wrap.appendChild(label);
	wrap.appendChild(content);

	label.appendChild(title);
	linkElement.appendChild(wrap);
};
